import { Button, MainList, Main } from "components";

import { ReactComponent as ShopIcon } from "icons/shop.svg";

import { sort, filters } from "./const/data";

const CurrenciesList = ({ history }) => (
  <Main
    page={{
      name: "Waluty",
      icon: <ShopIcon />,
      breadcrumbs: [
        {
          name: "Waluty",
        },
      ],
      buttons: <Button type="add" text="Dodaj walutę" path="/currencies/new" />,
    }}
  >
    <MainList
      query_key="currencies"
      api_path="/currencies"
      sort_column="id"
      sort_direction="desc"
      context="ui_index"
      sort={sort}
      filters={filters}
      handleNavigate={(item) => history.push(`/currencies/${item.id}`)}
      renderItem={({
        name,
        identifier,
        default_suggested_price_exchange_rate,
      }) => (
        <>
          <td>{name}</td>
          <td>{identifier}</td>
          <td>{default_suggested_price_exchange_rate}</td>
        </>
      )}
    />
  </Main>
);

export default CurrenciesList;
